export class ArchiveQueryEditorControls {
  public name: string;
  public description: string;
  public applicationName: string[];
  public subsystem: string[];
  public severities: number[];
  public textSql: string;
  public textLucene: string;
  public from: Date;
  public to: Date;
  public startTime: string;
  public endTime: string;
  public querySyntax: string;

  constructor(init?: Partial<ArchiveQueryEditorControls>) {
    Object.assign(this, init);
  }
}
